import { getDomain } from 'www/utils/get-domain';

const ArticlePoll = {
    init(ele) {
        let qnaApi = window.qna || null;
        
        let qnaEls = [...ele?ele.querySelectorAll('.qna-render'):document.querySelectorAll('.qna-render')];
        if (qnaEls.length > 0) {
            if (qnaApi != null) {
                this.load(qnaApi, ele);
            } else {
                /*
                    Load Q&A library if it isn't available
                */
                const scriptPath = 'medscape-core/qna-lib/js/qna.min.js';
                let url = `https://img.${getDomain()}medscapestatic.com/${scriptPath}`;
                fetch(url)
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Failed to load qna script');
                    }
                    return response.text();
                })
                .then(scriptText => {
                    const script = document.createElement('script');
                    script.textContent = scriptText;
                    document.body.appendChild(script);
                })
                .then(() => {
                    qnaApi = window.qna;
                    this.load(qnaApi, ele);
                })
                .catch(error => {
                    console.error('Error loading script:', error);
                });
            }
        }
    },
    load(qnaApi = window.qna, ele) {
        const qnas = [...ele?ele.querySelectorAll('.qna-render'):document.querySelectorAll('.qna-render')];
        qnas.forEach((qnaEl) => {
            if(Medscape.ArticlePage.type == "FAST_FIVE" && typeof qnaApi.createFastFivePoll != 'undefined'){               
                qnaApi.createFastFivePoll(qnaEl);
            }
            else{
                qnaApi.createArticlePoll(qnaEl);
            }
        });

    }
}


export { ArticlePoll }